// extracted by mini-css-extract-plugin
export default {"widthWrapper":"BankAccounts_widthWrapper__5Dmhw"};